import { useContext } from "react";
import StoresContext from "Contexts/StoresContext";
import RootStore from "stores/RootStore";

const useStores = (): typeof RootStore => useContext(StoresContext)

export default useStores